import * as React from "react";
import { Dialog, DialogContent } from "./dialog";
import { cn } from "@/lib/utils";

interface WidgetContainerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

export function WidgetContainer({
  isOpen,
  onClose,
  children,
  className,
}: WidgetContainerProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className={cn(
          "max-w-7xl w-[95vw] h-[90vh] p-6 overflow-y-auto",
          "scrollbar-thin scrollbar-track-transparent scrollbar-thumb-muted",
          className
        )}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
